import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import Raven from 'raven-js';
// @ts-expect-error untyped import
import { sendEmbedCodeEmail } from '../redux/actions/MeetingsEmailActions';
const useSendEmbedCodeEmail = () => {
  const dispatch = useDispatch();
  return useCallback((emailAddress, linkId) => dispatch(sendEmbedCodeEmail(emailAddress, linkId)).catch(reason => Raven.captureMessage('failed to send embed code', {
    extra: {
      reason,
      emailAddress,
      linkId
    }
  })), [dispatch]);
};
export default useSendEmbedCodeEmail;